import { createTheme } from '@material-ui/core/styles'; // Material-UI: the createMuiTheme function was renamed to createTheme.
import { esES } from '@material-ui/core/locale';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const baseTheme = {
    palette,
    typography,
    overrides
};

export const theme = createTheme(baseTheme, esES);
